import LegalLayout from './LegalLayout';

const MentionsLegales = () => {
  return (
    <LegalLayout
      title="Mentions légales"
      description="Mentions légales d'AlloRéparations Montpellier — éditeur, hébergeur, propriété intellectuelle et coordonnées."
      lastUpdated="27 avril 2026"
    >
      <section data-testid="section-editeur">
        <h2>1. Éditeur du site</h2>
        <p>
          Le site <strong>www.alloreparations.com</strong> est édité par&nbsp;:
        </p>
        <ul>
          <li><strong>Raison sociale&nbsp;:</strong> SERVICE REPARATIONS</li>
          <li><strong>Enseigne commerciale&nbsp;:</strong> AlloRéparations</li>
          <li><strong>Forme juridique&nbsp;:</strong> Société par actions simplifiée (SAS)</li>
          <li><strong>Capital social&nbsp;:</strong> 1&nbsp;000&nbsp;€</li>
          <li><strong>Siège social&nbsp;:</strong> 7 place des Martyrs de la Résistance, 34000 Montpellier, France</li>
          <li><strong>SIREN&nbsp;:</strong> 929&nbsp;491&nbsp;777</li>
          <li><strong>SIRET (siège)&nbsp;:</strong> 929&nbsp;491&nbsp;777&nbsp;00033</li>
          <li><strong>RCS&nbsp;:</strong> Montpellier 929&nbsp;491&nbsp;777</li>
          <li><strong>N° TVA intracommunautaire&nbsp;:</strong> FR47&nbsp;929&nbsp;491&nbsp;777</li>
          <li><strong>Code APE&nbsp;:</strong> 47.42Z (Commerce de détail de matériels de télécommunication en magasin spécialisé)</li>
          <li><strong>Téléphone&nbsp;:</strong> <a href="tel:+33983820754">09 83 82 07 54</a></li>
          <li><strong>SMS&nbsp;:</strong> <a href="sms:+33782373695">07 82 37 36 95</a></li>
          <li><strong>Email&nbsp;:</strong> <a href="mailto:alloreparations@gmail.com">alloreparations@gmail.com</a></li>
        </ul>
      </section>

      <section data-testid="section-directeur">
        <h2>2. Directeur de la publication</h2>
        <p>
          Le directeur de la publication est <strong>[Nom du Président — à compléter]</strong>,
          en qualité de Président de la société SERVICE REPARATIONS.
        </p>
      </section>

      <section data-testid="section-hebergeur">
        <h2>3. Hébergeur</h2>
        <p>
          Le site est hébergé par&nbsp;:
        </p>
        <ul>
          <li><strong>Nom&nbsp;:</strong> [À compléter — ex. OVH, Vercel, Netlify, Emergent…]</li>
          <li><strong>Adresse&nbsp;:</strong> [À compléter]</li>
          <li><strong>Téléphone&nbsp;:</strong> [À compléter]</li>
        </ul>
      </section>

      <section data-testid="section-propriete">
        <h2>4. Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments présents sur le site www.alloreparations.com (textes, images, logos, vidéos,
          graphismes, code source, structure, interface) sont la propriété exclusive d'AlloRéparations ou
          de leurs ayants droit respectifs. Toute reproduction, représentation, modification, publication,
          adaptation, totale ou partielle, sans autorisation écrite préalable est strictement interdite et
          constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la
          propriété intellectuelle.
        </p>
        <p>
          La marque <strong>AlloRéparations</strong>, le logo et tous les signes distinctifs sont protégés.
          Les marques tierces citées sur ce site (Apple, iPhone, iPad, MacBook, Samsung, Galaxy, Huawei,
          Xiaomi, Honor, Google Pixel, OnePlus, Oppo, Sony PlayStation, Microsoft Xbox, Nintendo Switch…)
          sont la propriété de leurs détenteurs respectifs et ne sont citées qu'à titre informatif pour
          décrire les services de réparation proposés. AlloRéparations n'est affilié à aucun de ces fabricants.
        </p>
      </section>

      <section data-testid="section-responsabilite">
        <h2>5. Responsabilité</h2>
        <p>
          AlloRéparations s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur
          le site. Toutefois, AlloRéparations ne peut garantir l'exactitude, la précision ou l'exhaustivité
          des informations mises à disposition. Les tarifs affichés sont donnés à titre indicatif et peuvent
          évoluer&nbsp;; un devis personnalisé est systématiquement établi avant toute intervention.
        </p>
        <p>
          AlloRéparations décline toute responsabilité quant aux liens hypertextes pointant vers d'autres
          sites depuis www.alloreparations.com et ne saurait être tenu responsable du contenu de ces sites tiers.
        </p>
      </section>

      <section data-testid="section-litiges">
        <h2>6. Loi applicable et juridiction</h2>
        <p>
          Les présentes mentions légales sont soumises à la loi française. En cas de litige et à défaut de
          résolution amiable, les tribunaux de Montpellier seront seuls compétents.
        </p>
        <p>
          Conformément à l'article L.612-1 du Code de la consommation, le client peut recourir gratuitement
          à un médiateur de la consommation en vue de la résolution amiable d'un litige.
        </p>
      </section>

      <section data-testid="section-contact">
        <h2>7. Contact</h2>
        <p>
          Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter&nbsp;:
        </p>
        <ul>
          <li>Par téléphone&nbsp;: <a href="tel:+33983820754">09 83 82 07 54</a></li>
          <li>Par email&nbsp;: <a href="mailto:alloreparations@gmail.com">alloreparations@gmail.com</a></li>
          <li>Par courrier&nbsp;: 7 place des Martyrs de la Résistance, 34000 Montpellier</li>
        </ul>
      </section>
    </LegalLayout>
  );
};

export default MentionsLegales;
